import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Radio, Form, Input, message, Button, DatePicker,Select, Cascader, TimePicker } from "antd";
import editIcon from "../../assets/pencil.png";
import { CloseOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import useJDStore from "../../store/jd.store";
import { SUPPORTED_EVENT_TYPE,  SUPPORTED_LOCATION} from "../../helper/categoryconstants" 
import "./jdEventCreationForm.scss";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export default function JDEventCreationForm({nujobsPost=false, setCurrentView }) {
    const [isEditMode, setIsEditMode] = useState(false);
    const [formKey, setFormKey] = useState(1);
    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("");
    const [deadlineDate, setDeadlineDate] = useState("");
    const [deadlineTime, setDeadlineTime] = useState("");    
    const [eventType, setEventType] = useState("");
    const [form] = Form.useForm();
    const { value } = useParams();
    const { updateJdEvent,getJdEventByID,selectedJD} = useJDStore();
    const [evenView, setEventView] = useState("noEvent"); //noEvent, yesEvent

    const onEventChange = (val) => {
        setEventType(val)
    };  
    const [eventValues, setEventValues] = useState({});       
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }   
        
    const initJDParams = (selectedEvent) =>{
        var eventValuesTmp
        if (value !== undefined) { 
            eventValuesTmp = {
                eventname: selectedEvent?.eventname,
                eventtype: selectedEvent?.eventtype,
                eventdesc: selectedEvent?.eventdesc,

                regrequired: selectedEvent?.regrequired,
                regscan: selectedEvent?.regscan,
                reglink: selectedEvent?.reglink, 

                startdate: dayjs(selectedEvent?.startdate, "DD-MM-YYYY"),
                starttime: dayjs(selectedEvent.starttime, "h:mm a"),
                enddate: dayjs(selectedEvent?.enddate, "DD-MM-YYYY"), 
                endtime: dayjs(selectedEvent.endtime, "h:mm a"),
                deadlinedate: selectedEvent?.deadlinedate?dayjs(selectedEvent?.deadlinedate,"DD-MM-YYYY"):null,
                deadlinetime: selectedEvent.deadlinetime?dayjs(selectedEvent.deadlinetime, "h:mm a"):null,

                venue: selectedEvent?.venue,
                city: selectedEvent?.city,
                googlemaplink: selectedEvent?.googlemaplink,

                venue2: selectedEvent?.venue2,
                city2: selectedEvent?.city2,
                googlemaplink2: selectedEvent?.googlemaplink2,

                venue3: selectedEvent?.venue3,
                city3: selectedEvent?.city3,
                googlemaplink3: selectedEvent?.googlemaplink3,                

                postingdate: selectedEvent?.postingdate ,
                postedby: selectedEvent?.postedby,
                updatedon: selectedEvent?.updatingdate,
                updatedby: selectedEvent?.updatedby,             
            };
            setEventValues(eventValuesTmp)
            setStartDate(selectedEvent?.startdate)
            setStartTime(selectedEvent.starttime)
            setEndDate(selectedEvent?.enddate)
            setEndTime(selectedEvent.endtime)
            setDeadlineDate(selectedEvent?.deadlinedate)
            setDeadlineTime(selectedEvent.deadlinetime)
            setEventType(selectedEvent?.eventtype)         
            setEventView("yesEvent")
        }
    }

    //selected jd from table
    useEffect(() => {
        getJdEventByID(value,initJDParams)
    }, []);
    useEffect(() => {
    if (evenView === "yesEvent") {
        form.setFieldsValue(eventValues);
    }
   }, [eventValues, evenView, form]);

  const handleStartDate = (Value, type) =>{
        var day = Value?.$D
        var month = Value?.$M +1
        if(Value?.$D < 10) day = '0'+ Value?.$D
        if(month < 10) month = '0'+ month
        var iDate = ''+day +"-"+ month+"-" + Value?.$y

        if(type == "start")
           setStartDate(iDate);
        else if (type == "end")
           setEndDate(iDate) 
        else
           setDeadlineDate(iDate)
  }
 
  const handleStartTime = (time,timeString) =>{
        setStartTime(timeString); 
  }
  const handleEndTime = (time,timeString) =>{
        setEndTime(timeString); 
  }
  const handleDeadlineTime = (time,timeString) =>{
        setDeadlineTime(timeString); 
  }

      function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }

    const encodeJson = (values,action) =>{

        let encodedJsonValues ={};

        //console.log("data to encode", values)
        //get company details
        encodedJsonValues.qhoid= userData.qhoid;
        encodedJsonValues.accounttype= userData.account_type;
        encodedJsonValues.companyname = userData.organization


        //jd
        encodedJsonValues.qhcompanyjid = value

        //now fill the parameters
        encodedJsonValues.eventname =values.eventname;
        encodedJsonValues.eventtype =eventType;        
        encodedJsonValues.eventdesc =values.eventdesc;
        encodedJsonValues.regrequired =values.regrequired;
        encodedJsonValues.regscan =values.regscan;
        encodedJsonValues.reglink =values.reglink;
        encodedJsonValues.startdate =startDate;
        encodedJsonValues.starttime =startTime;
        encodedJsonValues.enddate =endDate;
        encodedJsonValues.endtime =endTime;
        encodedJsonValues.deadlinedate =deadlineDate;
        encodedJsonValues.deadlinetime =deadlineTime;
        encodedJsonValues.venue =values.venue;
        encodedJsonValues.city =values.city;
        encodedJsonValues.googlemaplink =values.googlemaplink;
        encodedJsonValues.venue2 =values.venue2;
        encodedJsonValues.city2 =values.city2;
        encodedJsonValues.googlemaplink2 =values.googlemaplink2;
        encodedJsonValues.venue3 =values.venue3;
        encodedJsonValues.city3 =values.city3;
        encodedJsonValues.googlemaplink3 =values.googlemaplink3;                

        //get the current date
        let newDate = getTimeNow()
        if(selectedJD?.eventcreated == false){
            encodedJsonValues.postingDate= newDate;
            encodedJsonValues.postedby    = userData.username;
            encodedJsonValues.qhuid    = userData.qhuid;
        } 
        return encodedJsonValues
    }

  const handleUpdateFormSubmit = async (values) => {
    const jasonValues = encodeJson(values);
    try {
           await updateJdEvent({
            ...jasonValues
          },value);
          message.success("Event Updated Successfully");
          setIsEditMode(false);       
    } catch (err) {
          message.error("Failed to update Event. Please try again.");
          console.error("Error during Evenet creation:", err);
    }
   };
     
 
    return (
        <div className="jd-event-creation-form-wrapper">
            {
                evenView == "noEvent"?
                <>
                    <div className="header">
                        <Button
                                className="jd-creation-edit-button"
                                onClick={() => setEventView("yesEvent")}
                        >
                            <PlusOutlined /> Add New Event
                        </Button>          
                    </div>                    
                </>
                :<>
                    <div className="header">                      
                        {!isEditMode && value? (
                            <Button
                            className="jd-creation-edit-button"
                            onClick={() => setIsEditMode(true)}
                            type="primary"
                            >
                            <img src={editIcon} alt="Edit" width="14" height="14" />
                            </Button>
                        ) : value?(
                            <Button
                            className="jd-creation-edit-button"
                            onClick={() => setIsEditMode(false)}
                            >
                            <CloseOutlined /> Cancel
                            </Button>
                        ):<></>}  
                        <Button
                                className="jd-creation-edit-button"
                                onClick={() => setEventView("noEvent")}
                        >
                            <DeleteOutlined /> 
                        </Button>                                          
                    </div>
                    <Form
                        form = {form}
                        key={formKey}
                        className="jd-creation-form"
                        justify="start"
                        layout="vertical"
                        autoComplete="off"
                        onFinish={handleUpdateFormSubmit }
                        initialValues={eventValues}
        >               <h4>Event Details</h4>
                        <div className="dual-input-wrapper">
                            <Form.Item
                                className="jd-creation-field-item"
                                label="Event Name"
                                name="eventname"
                            >
                                <Input
                                    disabled={!isEditMode}
                                    placeholder={selectedJD?.JDDetails.Title + " Drive"}
                                    className="jd-creation-input"
                                />
                            </Form.Item>                    
                            <Form.Item
                                rules={[
                                    { required: true, message: 'Please select Event Type!' }
                                ]}   
                                className="jd-creation-field-item"
                                label="Event Type"
                                name="eventtype"
                            >
                                    <Select
                                        disabled={!isEditMode}
                                        required={true}
                                        size="small"
                                        className="jd-creation-input"                            
                                        placeholder="Please select"
                                        onChange={onEventChange}
                                        options={SUPPORTED_EVENT_TYPE}
                                    />                         
                            </Form.Item>
                        </div>

                        <Form.Item
                            required={true}
                            name="eventdesc"
                            className="jd-creation-field-item"
                            label="Event descriptions"
                        >
                                <ReactQuill
                                    theme="snow"
                                    readOnly={!isEditMode}
                                    value={form.getFieldValue("event_description") || ""}
                                    onChange={(value) => {
                                        form.setFieldValue("event_description", value);
                                    }}
                                /> 
                        </Form.Item>
                        <h4>Registration</h4>              
                        <div className="triple-input-wrapper">
                                <Form.Item
                                    className="jd-creation-field-item"
                                    label="Registration Required"
                                    name="regrequired"
                                >
                                <Radio.Group
                                    disabled={!isEditMode}
                                    defaultValue={false}
                                    className="jd-creation-radio-wrapper"
                                    rules={[{ required: true, message: "Please select an option" }]}
                                >
                                    <Radio
                                        className="radio-option"
                                        value={true}
                                    >
                                        Yes
                                    </Radio>
                                    <Radio
                                        className="radio-option"
                                        value={false}
                                    >
                                        No
                                    </Radio>
                                </Radio.Group>
                                </Form.Item>
                                <Form.Item
                                        name="reglink"
                                        className="jd-creation-field-item"
                                        label="Registration Link"
                                    >
                                        <Input
                                            disabled={!isEditMode}
                                            className="jd-creation-input"
                                        />
                                </Form.Item>
                                <Form.Item
                                        name="regscan"
                                        className="jd-creation-field-item"
                                        label="Scan and Register"
                                    >
                                        <Input
                                            disabled={!isEditMode}
                                            className="jd-creation-input"
                                        />
                                </Form.Item>                        
                        </div> 

                        <h4>Schedule</h4>
                    <div className="dual-input-wrapper">
                            <Form.Item
                                className="jd-creation-field-item"
                                label="Start Date"
                                name="startdate"
                                rules={[
                                            { required: true, message: 'Please select Job Permission!' }
                                ]}                         
                            >
                                <DatePicker 
                                    disabled={!isEditMode}
                                    className="jd-creation-input"
                                    onChange={(value)=>handleStartDate(value,"start")}
                                />                       
                            </Form.Item>
                            <Form.Item
                                    name="starttime"
                                    className="jd-creation-field-item"
                                    label="Time"
                                rules={[
                                            { required: true, message: 'Please select Job Permission!' }
                                ]}                             
                                >
                                    <TimePicker
                                        disabled={!isEditMode}
                                        use12Hours={true}
                                        format={"h:mm a"}                                
                                        className="jd-creation-input"
                                        onChange={(time,timeString)=>handleStartTime(time,timeString)}
                                    />
                            </Form.Item>
                        </div> 
                    <div className="dual-input-wrapper">
                            <Form.Item
                                className="jd-creation-field-item"
                                label="End Date"
                                name="enddate"
                                rules={[
                                            { required: true, message: 'Please select Job Permission!' }
                                ]}                         
                            >
                                <DatePicker 
                                    disabled={!isEditMode}
                                    className="jd-creation-input"
                                    onChange={(value)=>handleStartDate(value,"end")}
                                />  
                            </Form.Item>
                            <Form.Item
                                    name="endtime"
                                    className="jd-creation-field-item"
                                    label="Time"
                                rules={[
                                            { required: true, message: 'Please select Job Permission!' }
                                ]}                             
                                >
                                    <TimePicker
                                        disabled={!isEditMode}
                                        className="jd-creation-input"
                                        use12Hours={true}
                                        format={"h:mm a"}    
                                        onChange={(time,timeString)=>handleEndTime(time,timeString)}                                
                                    />
                            </Form.Item>
                        </div> 
                    <div className="dual-input-wrapper">
                            <Form.Item
                                className="jd-creation-field-item"
                                label="Registration Deadline"
                                name="deadlinedate"
                            >
                                <DatePicker 
                                    disabled={!isEditMode}
                                    className="jd-creation-input"
                                    onChange={(value)=>handleStartDate(value,"dealine")}
                                />  
                            </Form.Item>
                            <Form.Item
                                    name="deadlinetime"
                                    className="jd-creation-field-item"
                                    label="Time"
                                >
                                <TimePicker 
                                    disabled={!isEditMode}
                                    className="jd-creation-input"
                                    use12Hours={true}
                                    format={"h:mm a"} 
                                    onChange={(time,timeString)=>handleDeadlineTime(time,timeString)}   
                                />  
                            </Form.Item>
                        </div> 
                        <h4>Event Locations</h4>               
                        <div className="triple-input-wrapper">
                            <Form.Item
                                rules={[
                                            { required: true, message: 'Please select Work Location!' }
                                ]}   
                                name="venue"
                                className="jd-creation-field-item"
                                label="Venue/Address"
                            >
                                <TextArea
                                    disabled={!isEditMode}
                                    className="jd-creation-input"
                                />  
                            </Form.Item>   
                            <Form.Item
                                rules={[
                                            { required: true, message: 'Please select Job Permission!' }
                                ]}                           
                                name="city"
                                className="jd-creation-field-item"
                                label="City"
                            >
                                    <Select
                                        disabled={!isEditMode}
                                        placeholder="Please Select"
                                        className="jd-creation-input"
                                        allowClear                                                 
                                        options={SUPPORTED_LOCATION}
                                    />                          
                            </Form.Item>
                        <Form.Item
                                name="googlemaplink"
                                className="jd-creation-field-item"
                                label="Google Map Link"
                            >
                                <Input
                                    disabled={!isEditMode}
                                    className="jd-creation-input"
                                />     
                        </Form.Item>                      
                        </div>
                        <div className="triple-input-wrapper">
                        <Form.Item  
                                name="venue2"
                                className="jd-creation-field-item"
                                label="Venue/Address -2"
                            >
                                <TextArea
                                    disabled={!isEditMode}
                                    className="jd-creation-input"
                                />  
                            </Form.Item>   


                            <Form.Item                          
                                name="city2"
                                className="jd-creation-field-item"
                                label="City-2"
                            >
                                    <Select
                                        disabled={!isEditMode}
                                        size="small"
                                        placeholder="Please Select"
                                        className="jd-creation-input"
                                        allowClear                                                 
                                        options={SUPPORTED_LOCATION}
                                    />                          
                            </Form.Item>
                            <Form.Item
                                    name="googlemaplink2"
                                    className="jd-creation-field-item"
                                    label="Google Map Link -2"
                                >
                                    <Input
                                        disabled={!isEditMode}
                                        className="jd-creation-input"
                                    />     
                            </Form.Item>                      
                        </div>
        
                        <div className="triple-input-wrapper">
                            <Form.Item  
                                name="venue3"
                                className="jd-creation-field-item"
                                label="Venue/Address -3"
                            >
                                <TextArea
                                    disabled={!isEditMode}
                                    className="jd-creation-input"
                                />  
                            </Form.Item>   


                            <Form.Item                          
                                name="city3"
                                className="jd-creation-field-item"
                                label="City-3"
                            >
                                    <Select
                                        disabled={!isEditMode}
                                        size="small"
                                        placeholder="Please Select"
                                        className="jd-creation-input"
                                        allowClear                                                 
                                        options={SUPPORTED_LOCATION}
                                    />                          
                            </Form.Item>
                            <Form.Item
                                    name="googlemaplink3"
                                    className="jd-creation-field-item"
                                    label="Google Map Link -3"
                                >
                                    <Input
                                        disabled={!isEditMode}
                                        className="jd-creation-input"
                                    />     
                            </Form.Item>                      
                        </div>                                                                         
                            {value ? (
                            <>
                                <div className="dual-input-wrapper">
                                <Form.Item
                                    name="postingdate"
                                    className="jd-creation-field-item"
                                    label="Created On"
                                >
                                    <Input disabled={true} className="jd-creation-input" />
                                </Form.Item>
                                <Form.Item
                                    name="postedby"
                                    className="jd-creation-field-item"
                                    label="Created By"
                                >
                                    <Input disabled={true} className="jd-creation-input" />
                                </Form.Item>
                                </div>
                                <div className="dual-input-wrapper">
                                <Form.Item
                                    name="updatedon"
                                    className="jd-creation-field-item"
                                    label="Last Updated"
                                >
                                    <Input disabled={true} className="jd-creation-input" />
                                </Form.Item>
                                <Form.Item
                                    name="updatedby"
                                    className="jd-creation-field-item"
                                    label="Updated By"
                                >
                                    <Input disabled={true} className="jd-creation-input" />
                                </Form.Item>
                                </div>
                            </>
                            ) : (
                            <></>
                            )}
                        <Button
                            style={{ width: "100%", height: "40px", fontWeight: "600" }}
                            type="primary"
                            disabled={!isEditMode &&  value !== undefined }
                            htmlType="submit"
                        >
                            {value !== undefined ?
                            <>Submit Event Details</>
                            :<>First Create JD</>}
                            
                        </Button>
                    </Form>
                </>
            }
        </div>
    );
}
